import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Carousel from 'react-elastic-carousel';
import { Dot } from './Dot';
import { Slide } from './Slide';
import { Wrapper, Controls } from './styles';

export const GetStartedCarousel = ({ slides, children }) => {
  const carouselRef = useRef();
  const [step, setStep] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const goTo = index => {
    setAutoPlay(false);
    carouselRef.current.goTo(index);
  };

  return (
    <Wrapper>
      <Carousel
        ref={carouselRef}
        showArrows={false}
        enableAutoPlay={autoPlay}
        autoPlaySpeed={4000}
        onChange={(_obj, next) => setStep(next)}
        renderPagination={() => <></> /* avoid default pagination */}
      >
        {slides.map(slide => (
          <Slide key={slide.heading} {...slide} />
        ))}
      </Carousel>

      {children}

      <Controls>
        {slides.map((_slide, index) => (
          <Dot
            key={index}
            label={`Slide ${index + 1} of ${slides.length}`}
            isActive={step === index}
            onClick={() => goTo(index)}
          />
        ))}
      </Controls>
    </Wrapper>
  );
};

GetStartedCarousel.displayName = 'GetStartedCarousel';

GetStartedCarousel.propTypes = {
  children: PropTypes.node,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      img: PropTypes.string,
      imgAlt: PropTypes.string,
      heading: PropTypes.string,
      text: PropTypes.string,
    }).isRequired,
  ),
};
